import * as React from "react";

import {
  SkeletonGenerator,
  Section,
  Skeleton,
  Margins,
  Container,
  Row,
  Column,
} from "@ui/Atoms";

const PageSkeleton = React.memo(() => (
  <SkeletonGenerator count={9} randomWidth={75} />
));

PageSkeleton.displayName = "PageSkeleton";

const BlockPageSkeleton = React.memo(() => (
  <Row>
    <Column lg={12}>
      <SkeletonGenerator count={4} shape="rectVertical" randomHeight={180} />
    </Column>
  </Row>
));

BlockPageSkeleton.displayName = "BlockPageSkeleton";

const SidebarSkeleton = React.memo(() => (
  <SkeletonGenerator count={2} shape="rectVertical" noGutter />
));

SidebarSkeleton.displayName = "SidebarSkeleton";

const LoadingDashboardSkeleton = () => (
  <Section small>
    <React.Fragment>
      {/* eslint-disable no-mixed-operators */}
      {Array.from(
        { length: Math.random() * (10 - 1) + 1 },
        () => Math.random() * (100 - 25) + 25,
      ).map((item: number) => (
        <Skeleton style={{ width: `${item}%` }} key={`k-${item}`} />
      ))}
      {/* eslint-enable no-mixed-operators */}
    </React.Fragment>
  </Section>
);

LoadingDashboardSkeleton.displayName = "LoadingDashboardSkeleton";

const ProfileDashboardSkeleton = () => (
  <Margins xs={["base_x2", "base_x2", null, null]}>
    <Container>
      <Row>
        <Column lg={8}>
          <Skeleton shape="row" />
          <SkeletonGenerator
            count={4}
            shape="rectVertical"
            randomHeight={180}
          />
        </Column>
        <Column lg={4}>
          <Skeleton />
          <Skeleton shape="rectVertical" />
          <Skeleton shape="rectVertical" />
          <Skeleton />
        </Column>
      </Row>
    </Container>
  </Margins>
);

ProfileDashboardSkeleton.displayName = "ProfileDashboardSkeleton";

const MyCleaningsDashboardSkeleton = () => (
  <Margins xs={["base_x4", "base_x4", null, null]}>
    <div>
      <SkeletonGenerator count={1} shape="rectVertical" randomHeight={140} />
      <SkeletonGenerator
        count={2}
        shape="rectVertical"
        randomHeight={160}
        noGutter
      />
    </div>
  </Margins>
);

MyCleaningsDashboardSkeleton.displayName = "MyCleaningsDashboardSkeleton";

const BookingsToValidateDashboardSkeleton = () => (
  <Margins xs={["base_x4", "base_x4", null, null]}>
    <div>
      <SkeletonGenerator count={1} shape="rectVertical" customHeight={320} />
    </div>
  </Margins>
);

BookingsToValidateDashboardSkeleton.displayName =
  "BookingsToValidateDashboardSkeleton";

const OptionsDashboardSkeleton = () => (
  <Margins xs={["base_x4", "base_x4", null, null]}>
    <div>
      <SkeletonGenerator count={1} shape="rectVertical" customHeight={320} />
      <SkeletonGenerator count={2} shape="rectVertical" randomHeight={260} />
    </div>
  </Margins>
);

OptionsDashboardSkeleton.displayName = "OptionsDashboardSkeleton";

const MyEmployeesListSkeleton = () => (
  <Margins xs={["base_x4", "base_x4", null, null]}>
    <div>
      <SkeletonGenerator count={3} shape="rectVertical" customHeight={140} />
    </div>
  </Margins>
);

MyEmployeesListSkeleton.displayName = "MyEmployeesListSkeleton";

const EmployeeSkeleton = () => (
  <Margins xs={["base_x4", "base_x4", null, null]}>
    <div>
      <SkeletonGenerator
        count={1}
        shape="rectVertical"
        randomHeight={120}
        noGutter
      />
      <SkeletonGenerator count={1} shape="rectVertical" randomHeight={120} />

      <SkeletonGenerator count={1} shape="rectVertical" customHeight={160} />

      <SkeletonGenerator
        count={1}
        shape="rectVertical"
        randomHeight={120}
        noGutter
      />
      <SkeletonGenerator count={1} shape="rectVertical" randomHeight={120} />
    </div>
  </Margins>
);

EmployeeSkeleton.displayName = "EmployeeSkeleton";

const ApplyFormFirstPageSkeleton = () => (
  <Margins xs={["base_x4", "base_x4", null, null]}>
    <div>
      <SkeletonGenerator count={1} shape="rectVertical" customHeight={260} />
      <SkeletonGenerator count={1} shape="rectVertical" customHeight={120} />
    </div>
  </Margins>
);

ApplyFormFirstPageSkeleton.displayName = "ApplyFormFirstPageSkeleton";

const ApplyFormShortPageSkeleton = () => (
  <Margins xs={["base_x4", "base_x4", null, null]}>
    <div>
      <SkeletonGenerator count={1} shape="rectVertical" customHeight={560} />
      <SkeletonGenerator count={1} shape="rectVertical" customHeight={120} />
    </div>
  </Margins>
);

ApplyFormShortPageSkeleton.displayName = "ApplyFormShortPageSkeleton";

const ApplyFormLongPageSkeleton = () => (
  <Margins xs={["base_x4", "base_x4", null, null]}>
    <div>
      <SkeletonGenerator count={6} shape="rectVertical" randomHeight={200} />
      <SkeletonGenerator count={1} shape="rectVertical" customHeight={120} />
    </div>
  </Margins>
);

ApplyFormLongPageSkeleton.displayName = "ApplyFormLongPageSkeleton";

const SummaryFeaturesSkeleton = () => (
  <div>
    <SkeletonGenerator count={1} shape="rectVertical" customHeight={200} />
  </div>
);

SummaryFeaturesSkeleton.displayName = "SummaryFeaturesSkeleton";

export {
  SidebarSkeleton,
  BlockPageSkeleton,
  PageSkeleton,
  LoadingDashboardSkeleton,
  ProfileDashboardSkeleton,
  MyCleaningsDashboardSkeleton,
  OptionsDashboardSkeleton,
  BookingsToValidateDashboardSkeleton,
  MyEmployeesListSkeleton,
  EmployeeSkeleton,
  ApplyFormFirstPageSkeleton,
  ApplyFormShortPageSkeleton,
  ApplyFormLongPageSkeleton,
  SummaryFeaturesSkeleton,
};
